import { render } from "./ValidationResultsHeader.vue?vue&type=template&id=0d8b5960&scoped=true"
import script from "./ValidationResultsHeader.vue?vue&type=script&lang=js"
export * from "./ValidationResultsHeader.vue?vue&type=script&lang=js"

import "./ValidationResultsHeader.vue?vue&type=style&index=0&id=0d8b5960&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d8b5960"]])

export default __exports__